import React from 'react';

import './ConnectMessages.scss';

export const AccessDeniedMessage: React.FC = () => (
  <>
    <h2 className="connect-message-title">Access denied</h2>
    <p>Doesn't seem like you have the necessary roles to access this subscription.</p>
    <p>
      Ask a user who has more rights on this subscription to grant you the necessary permissions.
    </p>
  </>
);
